// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

//ENUMS
// eslint-disable-next-line no-unused-vars
import { CustomerType } from "@/enums/customerType";
// eslint-disable-next-line no-unused-vars
import { PlanFilterType } from "@/enums/planFilter";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Customer Get
/**
 *
 * @param {{params: object, query: {maxLongitude: number, minLongitude: number, maxLatitude: string, minLatitude: string, userType: CustomerType, page: number, limit: number, lastPlanFilter: PlanFilterType, isYearCustomer: boolean, searchKey: string, regionId: string, employeeId: string}}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Customer.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Customer Get
/**
 *
 * @param {{params: object, query: {customerId: string, startDate: string, endDate: string}}} option
 *
 * @returns
 */
export const GetSaleStatsOfCustomerByDateRange = async (option) => {
  const response = await $api.get(
    Endpoints.Customer.GetSaleStatsOfCustomerByDateRange(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Customer Create
/**
 *
 * @param { fullName: string, phoneNo: string, taxNo: string, taxOffice: string, email: string, faxNo: string, address: { province: string, district: string, address: string, lattitude: string, longitude: string, buildingNo: string, floorNo: string, apartmentNo: string, country: string, postalCode: string }, shippingAddress: { province: string, district: string, address: string, lattitude: string, longitude: string, buildingNo: string, floorNo: string, apartmentNo: string, country: string, postalCode: string, workStartTime: string, workEndTime: string, workFinishTime: string, yearTime: string, employeeId: string | null, image: File, isAbroad: boolean, regionId: string, shortName: string, companyName: string, userType: CustomerType } } form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Customer.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Customer.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer Update
/**
 *
 * @param {{
 *   parasutAccountId?: string,
 *   transferParasut?: boolean,
 *   fullName?: string,
 *   phoneNo?: string,
 *   taxNo?: string,
 *   taxOffice?: string,
 *   email?: string,
 *   faxNo?: string,
 *   address?: object,
 *   shippingAddress?: object,
 *   workStartTime?: number,
 *   workFinishTime?: number,
 *   yearTime?: string,
 *   yearTimePrice?: number,
 *   yearTimeStart?: string,
 *   image?: string,
 *   employeeId?: string,
 *   isActive?: boolean,
 *   isAbroad?: boolean,
 *   regionId?: string,
 *   shortName?: string,
 *   companyName?: string,
 *   userType?: CustomerType,
 *   tagIds?: string[],
 *   contactType?: string
 * }} form
 * @param {{params: { id: string }, query?: object}} option
 *
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Customer.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Customer.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer Delete
/**
 *
 * @param {{params: { id: string }, query: object}} form
 
 * @returns
 */
export const UpdateNewCustomerBonusLimit = async (form) => {
  const response = await $api.put(
    Endpoints.Customer.UpdateNewCustomerBonusLimit(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export const UpdateNewCustomerBonusAmount = async (form) => {
  const response = await $api.put(
    Endpoints.Customer.UpdateNewCustomerBonusAmount(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export const GetCustomerBonusSettings = async (option) => {
  const response = await $api.get(
    Endpoints.Customer.GetCustomerBonusSettings(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{ query?: {
 *   customerId?: string,
 *   saleId?: string,
 *   employeeId?: string,
 *   regionId?: string,
 *   startDate?: string,
 *   endDate?: string,
 *   paymentType?: "Cash" | "NoInstallmentCreditCard" | "WithInstallmentCreditCard" | "PromissorySale",
 *   onlyOpens?: boolean,
 *   companyId?: string,
 *   page?: number,
 *   limit?: number,
 *   search?: string
 * }}} option
 */
export const GetCustomerPayments = async (option) => {
  const response = await $api.get(
    Endpoints.Customer.GetCustomerPayments(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * Müşteri borç kaydının yalnızca vade tarihini günceller.
 * @param {{ operationDate: string }} form
 * @param {{ params: { id: string } }} option
 */
export const UpdateCustomerPaymentDate = async (form, option) => {
  const response = await $api.put(
    Endpoints.Customer.UpdateCustomerPaymentDate(option),
    form
  );
  if (response?.result === "OK" && response?.isSuccess !== false) {
    return { ...response, message: response.message || "OK", isSuccess: true };
  }
  const code =
    response?.exceptionMessage ||
    (response?.message && response.message !== "FAIL"
      ? response.message
      : null);
  return {
    ...response,
    message: code || "FAIL",
    isSuccess: false,
    exceptionMessage: code || response?.exceptionMessage || null,
  };
};

// ## Customer ImportExcel
/**
 * @param {File} file
 * @returns
 */
export const ImportExcel = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const response = await $api.post(Endpoints.Customer.ImportExcel(), fd);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer GetImportExcel
/**
 * @param {{ query: { page: number, limit: number } }} option
 * @returns
 */
export const GetImportExcel = async (option) => {
  const response = await $api.get(Endpoints.Customer.GetImportExcel(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer DeleteImportExcel
/**
 * Excel aktarımıyla eklenen ve planı olmayan müşterileri toplu siler.
 * @param {{ params: { customerExcelImportId: string } }} option
 * @returns {Promise<{ isSuccess: boolean, message: string, data: { customerExcelImportId: string, importedCustomerCount: number, deletedCount: number, excludedCount: number, excludeCustomers: Array<{ id: string, fullName: string, phoneNo: string, taxNo: string, reason: string }> } }>}
 */
export const DeleteImportExcel = async (option) => {
  const response = await $api.delete(
    Endpoints.Customer.DeleteImportExcel(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 * @param {{
 *   query: {
 *     taxNo?: string,
 *     phoneNo?: string,
 *     email?: string,
 *     excludeCustomerId?: string
 *   }
 * }} option
 */
export const DuplicateCheck = async (option) => {
  const response = await $api.get(Endpoints.Customer.DuplicateCheck(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   sourceCustomerId: string,
 *   targetCustomerId: string,
 *   isConfirmed: boolean
 * }} form
 */
export const Merge = async (form) => {
  const response = await $api.post(Endpoints.Customer.Merge(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { operationId: string } }} option
 */
export const GetMerge = async (option) => {
  const response = await $api.get(Endpoints.Customer.GetMerge(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * LocationId'si null veya boş olan müşterilerin lokasyonlarını otomatik çözer (Admin).
 */
export const ResolveMissingLocations = async () => {
  const response = await $api.post(
    Endpoints.Customer.ResolveMissingLocations(),
    {}
  );
  if (response?.result === "OK" && response?.isSuccess !== false) {
    return { ...response, message: "OK", isSuccess: true };
  }
  if (response?.isSuccess === true || response?.message === "OK") {
    return { ...response, message: "OK", isSuccess: true };
  }
  return {
    message: "FAIL",
    isSuccess: false,
    data: null,
    exceptionMessage: response?.exceptionMessage || null,
  };
};

export default {
  GetAll,
  GetSaleStatsOfCustomerByDateRange,
  Create,
  GetById,
  Update,
  Delete,
  UpdateNewCustomerBonusLimit,
  UpdateNewCustomerBonusAmount,
  GetCustomerBonusSettings,
  GetCustomerPayments,
  UpdateCustomerPaymentDate,
  ImportExcel,
  GetImportExcel,
  DeleteImportExcel,
  DuplicateCheck,
  Merge,
  GetMerge,
  ResolveMissingLocations,
};
